import { useContext, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { Loading, PolicyRuleAlerts, policyRuleDisplayMessagePlacements, refundMethods } from '@reveni-io/reveni-ui'

import ConsentModal from '../components/ConsentModal/ConsentModal'
import PolicyRuleMessageWrapper from '../components/PolicyRuleMessageWrapper/PolicyRuleMessageWrapper'
import AppContext from '../context/AppContext'
import useConsentModal from '../hooks/useConsentModal/useConsentModal'
import routes from '../Router/routes.constants'
import useSendRefundMethod from './../hooks/useSendRefundMethod/useSendRefundMethod'
import BankAccountDrawer from './BankAccountDrawer/BankAccountDrawer'
import useBankAccountMethod from './hooks/useBankAccountMethod/useBankAccountMethod'
import RefundMethodButtons from './RefundMethodButtons/RefundMethodButtons'
import * as Styles from './styles'

const RefundSelectionPage = () => {
  const navigation = useNavigate()
  const location = useLocation()
  const { context, setContext } = useContext(AppContext)
  const { loading: fetchingReturnInfo } = useSendRefundMethod(context.orderInfo.id, context.orderInfo.returnId, null)
  const { showBankAccountDrawer, openBankAccountDrawer, closeBankAccountDrawer } = useBankAccountMethod()
  const { consentModal, showConsentModal, askForConsent, confirmConsent, closeConsentModal } = useConsentModal(
    policyRuleDisplayMessagePlacements.refundMethodPage
  )

  useEffect(() => {
    window.scrollTo({ top: 0 })
  }, [])

  const updateRefundType = refundType => {
    setContext(context => ({
      ...context,
      orderInfo: {
        ...context.orderInfo,
        refundType,
      },
    }))
  }

  const handleOriginalPaymentMethod = () => {
    if (askForConsent()) return

    updateRefundType(refundMethods.originalPaymentMethod)
    navigation(`${routes.summaryPage}?refundType=${refundMethods.originalPaymentMethod}`, {
      state: { from: location },
    })
  }

  const handleStoreCredit = () => {
    if (askForConsent()) return

    updateRefundType(refundMethods.storeCredit)
    navigation(`${routes.summaryPage}?refundType=${refundMethods.storeCredit}`, { state: { from: location } })
  }

  const handleBankTransfer = async () => {
    if (askForConsent()) return

    updateRefundType(refundMethods.bankTransfer)

    openBankAccountDrawer()
  }

  const handleGiftCard = () => {
    if (askForConsent()) return

    updateRefundType(refundMethods.giftCard)
    navigation(`${routes.summaryPage}?refundType=${refundMethods.giftCard}`, { state: { from: location } })
  }

  return (
    <Loading height="50px" show={fetchingReturnInfo}>
      <PolicyRuleMessageWrapper>
        <PolicyRuleAlerts
          displayMessages={context.displayMessages}
          placement={policyRuleDisplayMessagePlacements.refundMethodPage}
          includeGlobalMessages
        />
      </PolicyRuleMessageWrapper>
      <Styles.MainContainer>
        <RefundMethodButtons
          handleBankTransfer={handleBankTransfer}
          handleOriginalPaymentMethod={handleOriginalPaymentMethod}
          handleStoreCredit={handleStoreCredit}
          handleGiftCard={handleGiftCard}
          refundMethods={context.orderInfo.allowed_refund_methods}
          issueRefundAtStatus={context.orderInfo.issue_refund_at_status}
          disabledPreselectedRefundMethod={context.merchantInfo.preferences?.disable_preselected_refund_methods}
        />
      </Styles.MainContainer>
      <BankAccountDrawer show={showBankAccountDrawer} onClose={closeBankAccountDrawer} />
      <ConsentModal
        show={showConsentModal}
        consentModal={consentModal}
        onConfirm={confirmConsent}
        onClose={closeConsentModal}
      />
    </Loading>
  )
}

export default RefundSelectionPage
